module.exports = __webpack_public_path__ + "img/LUB00077.688df478.png";